import { Skeleton } from '@pocketlaw/tetris';
import { Container } from './TemplateCard/styled';
export function ItemLoader() {
    return (<Container>
      <Skeleton loading width="100%" height="10rem"/>
    </Container>);
}
